<div class="reg-page">
  <div class="reg-card app-card">

    <div class="reg-brand">
      <span class="material-symbols-outlined reg-brand-icon">admin_panel_settings</span>
      <h1 class="reg-brand-title">Radwa Khallaf</h1>
      <span class="reg-brand-badge">{{ 'auth.admin_registration' | translate }}</span>
    </div>

    <form [formGroup]="registerForm" class="reg-form">

      <div class="lx-field-group">
        <label class="lx-field-label" for="regEmail">{{ 'lbl.email_address' | translate }}</label>
        <input
          formControlName="email"
          id="regEmail"
          type="email"
          class="lx-input"
          [placeholder]="'ph.email' | translate"
          autocomplete="email"
        />
        <span class="lx-field-error" *ngIf="registerForm.controls?.email?.errors?.required && registerForm.controls?.email?.touched">
          {{ 'err.email_required' | translate }}
        </span>
        <span class="lx-field-error" *ngIf="registerForm.controls?.email?.errors?.pattern && registerForm.controls?.email?.touched">
          {{ 'err.email_invalid' | translate }}
        </span>
      </div>

      <div class="lx-field-group">
        <label class="lx-field-label" for="regUsername">{{ 'lbl.username' | translate }}</label>
        <input
          formControlName="username"
          id="regUsername"
          type="text"
          class="lx-input"
          [placeholder]="'ph.username_eg' | translate"
          autocomplete="username"
        />
        <span class="lx-field-error" *ngIf="registerForm.controls?.username?.errors?.required && registerForm.controls?.username?.touched">
          {{ 'err.username_required' | translate }}
        </span>
      </div>

      <div class="lx-field-group">
        <label class="lx-field-label" for="regName">{{ 'lbl.full_name' | translate }}</label>
        <input
          formControlName="name"
          id="regName"
          type="text"
          class="lx-input"
          [placeholder]="'ph.full_name' | translate"
          autocomplete="name"
        />
        <span class="lx-field-error" *ngIf="registerForm.controls?.name?.errors?.required && registerForm.controls?.name?.touched">
          {{ 'err.name_required' | translate }}
        </span>
      </div>

      <div class="lx-field-group">
        <label class="lx-field-label" for="regPhone">{{ 'lbl.phone_number' | translate }}</label>
        <input
          formControlName="phone_number"
          id="regPhone"
          type="tel"
          class="lx-input"
          [placeholder]="'ph.phone_admin' | translate"
          autocomplete="tel"
        />
        <span class="lx-field-error" *ngIf="registerForm.controls?.phone_number?.errors?.required && registerForm.controls?.phone_number?.touched">
          {{ 'err.phone_required' | translate }}
        </span>
        <span class="lx-field-error" *ngIf="(registerForm.controls?.phone_number?.errors?.minlength || registerForm.controls?.phone_number?.errors?.maxlength) && registerForm.controls?.phone_number?.touched">
          {{ 'err.phone_length' | translate }}
        </span>
      </div>

      <div class="lx-field-group">
        <label class="lx-field-label" for="regPassword">{{ 'lbl.password' | translate }}</label>
        <input
          formControlName="password"
          id="regPassword"
          type="password"
          class="lx-input"
          placeholder="Min 8 characters"
          autocomplete="new-password"
        />
        <span class="lx-field-error" *ngIf="registerForm.controls?.password?.errors?.required && registerForm.controls?.password?.touched">
          {{ 'err.password_required' | translate }}
        </span>
        <span class="lx-field-error" *ngIf="registerForm.controls?.password?.errors?.minlength && registerForm.controls?.password?.touched">
          {{ 'err.password_min' | translate }}
        </span>
        <span class="lx-field-error" *ngIf="registerForm.controls?.password?.errors?.maxlength && registerForm.controls?.password?.touched">
          {{ 'err.password_max' | translate }}
        </span>
      </div>

      <div class="lx-field-group lx-field-group--toggle">
        <label class="lx-toggle-label">
          <input
            formControlName="is_super_admin"
            type="checkbox"
            class="lx-toggle-input"
          />
          <span class="lx-toggle-track"></span>
          <span class="lx-toggle-text">{{ 'auth.grant_super' | translate }}</span>
        </label>
        <p class="lx-field-hint">{{ 'auth.super_hint' | translate }}</p>
      </div>

      <button
        [disabled]="registerForm.invalid"
        (click)="register()"
        type="button"
        class="reg-btn"
      >
        <span class="material-symbols-outlined">person_add</span>
        {{ 'btn.create_admin' | translate }}
      </button>

    </form>
  </div>
</div>
